module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"searchProducts":"Search products .... ","suggestedProducts":"Product Suggestions ({count})","suggestedCategories":"Categories","noResults":"No results found"},"ar":{"searchProducts":"البحث عن المنتجات","suggestedProducts":"منتجات مقترحة","suggestedCategories":"الاقسام","noResults":"لا توجد نتائج"}}')
  delete Component.options._Ctor
}
